const TOKEN_KEY = 'geohub_token';
const USER_KEY  = 'geohub_user';

const listeners = new Set();

function notify() { for (const fn of listeners) fn(getCurrentUser()); }

function getCurrentUser() {
  const raw = localStorage.getItem(USER_KEY);
  return raw ? JSON.parse(raw) : null;
}

export const auth = {
  getToken: () => localStorage.getItem(TOKEN_KEY),
  getUser:  () => getCurrentUser(),
  isAuthenticated: () => !!localStorage.getItem(TOKEN_KEY),

  set(token, user) {
    localStorage.setItem(TOKEN_KEY, token);
    if (user) localStorage.setItem(USER_KEY, JSON.stringify(user));
    notify();
  },

  setUser(user) {
    localStorage.setItem(USER_KEY, JSON.stringify(user));
    notify();
  },

  clear() {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    notify();
  },

  onChange(fn) {
    listeners.add(fn);
    return () => listeners.delete(fn);
  }
};
